// extracted by mini-css-extract-plugin
export default {"FileUploadDialog":"styles_FileUploadDialog__6dRbe","clickChooseFileMessage":"styles_clickChooseFileMessage__gvXxH","title":"styles_title__5S3Bj"};